import * as React from 'react'
import { makeLongTextConfig } from '../../survey/questionTypes/LongTextQuestionDisplay'
import { makeTextConfig } from '../../survey/questionTypes/TextQuestionDisplay'
import { QuestionPageDescription } from '../../survey/surveyBlocks'
import { FormInputProps } from '../../survey/types'

const EVERY_EMPLOYEE_HAS_A_HOME_PAY_GROUP = makeLongTextConfig({
  questionText: 'Home pay group',
  questionSubtext:
    'Do your employees have one "home" pay group where they always get paid regardless of where they worked?',
  questionId: 'everyEmployeeHasAHomeLocation',
  placeholder:
    'e.g., No, most employees are always in one pay group, but a few managers move between pay groups',
  required: true,
})
const EveryEmployeeHasAHomeLocation = EVERY_EMPLOYEE_HAS_A_HOME_PAY_GROUP.Input
const HOME_PAY_GROUP_TRACKING_SYSTEM = makeTextConfig({
  questionText: 'How do you track employees’ home pay groups?',
  questionId: 'homePayGroupTrackingSystem',
  placeholder: 'e.g., In a spreadsheet',
  required: false,
})
const HomeLocationTrackingSystem = HOME_PAY_GROUP_TRACKING_SYSTEM.Input

const HOW_OFTEN_BORROW = makeTextConfig({
  questionText: 'Temporary "borrows"',
  questionSubtext:
    'How often do you borrow an employee from another pay group? How do you handle their pay in those cases?',
  questionId: 'howOftenBorrow',
  placeholder: 'e.g., About once or twice a month.',
  required: false,
})
const HowOftenBorrow = HOW_OFTEN_BORROW.Input

const HOW_OFTEN_TRANSFER = makeTextConfig({
  questionText: 'Permanent pay group "transfers"',
  questionSubtext:
    'How often do employees permanently move to a different home pay group, and how do you process that?',
  questionId: 'howOftenTransfer',
  placeholder: 'e.g, A few times a year.',
  required: false,
})
const HowOftenTransfer = HOW_OFTEN_TRANSFER.Input

const HOW_NOTIFIED_OF_BORROW_OR_TRANSFER = makeLongTextConfig({
  questionText: 'Notification process',
  questionSubtext: 'How do you learn about a borrow or transfer — forms, emails, system alerts?',
  questionId: 'howNotifiedOfBorrowOrTransfer',
  placeholder:
    'e.g., GMs submit a form to the payroll manager each Tuesday before payroll deadline. The form is here: (link to form).',
  required: false,
})
const HowNotifiedOfBorrowOrTransfer = HOW_NOTIFIED_OF_BORROW_OR_TRANSFER.Input

const QUESTIONS = [
  EVERY_EMPLOYEE_HAS_A_HOME_PAY_GROUP,
  HOME_PAY_GROUP_TRACKING_SYSTEM,
  HOW_OFTEN_BORROW,
  HOW_OFTEN_TRANSFER,
  HOW_NOTIFIED_OF_BORROW_OR_TRANSFER,
] as const
const MultiPayGroupInputs = ({ register }: FormInputProps) => {
  return (
    <>
      <QuestionPageDescription>
        Alice helps multi-pay-group employers automatically manage employees who move between pay groups,
        whether it&apos;s rarely or often. Understanding how your team manages borrowing and transfers saves
        you time and ensures Alice benefits appear on the right paycheck, in the right pay group, at the right
        time.
      </QuestionPageDescription>

      <EveryEmployeeHasAHomeLocation register={register} />
      <HomeLocationTrackingSystem register={register} />
      <HowOftenBorrow register={register} />
      <HowOftenTransfer register={register} />
      <HowNotifiedOfBorrowOrTransfer register={register} />
    </>
  )
}

export const multiPayGroupInputs = {
  Page: MultiPayGroupInputs,
  questions: QUESTIONS,
}
